module.exports = [
  "Alex",
  "Hamisi",
  "Feisal",
  "Shabani",
  "Maswi",
  "Usama",
  "Kimaro",
  "Kelvin",
  "Juma",
  "Anita",
  "Anna",
  "Amina",
  "Mary",
  "Neema",
  "Glory",
  "Editha",
  "Happy",
  "Jackline",
  "Irene",
  "Martha",
  "Janeth",
  "Rehema",
  "Alice",
  "Euodia",
  "Grace",
  "Leah",
  "Victoria",
  "Brenda",
  "Perucy",
  "Rose",
  "Monalisa",
  "Josephine",
  "Elizabeth",
  "Benes",
  "Lilian",
  "Judith",
  "Emmy",
  "Rosa",
  "Sally",
  "Jojo",
  "Dorcas",
  "Raider",
  "Jacqueline",
  "Prisca",
  "Lisamae",
  "Saraphina",
  "Sheila",
  "Lolu",
  "Monica",
  "Witness",
  "Nasra",
  "Sophia",
  "Nuru",
  "Ro",
  "Neysha",
  "Oprahnash",
  "Kristen",
  "Jeudeth",
  "Kirie",
  "Ricky",
  "Narry",
  "Khadijah",
  "Vanessa",
  "Zulfy",
  "Jack",
  "Nommy",
  "Riziki",
  "Anno",
  "Dativa",
  "Janel",
  "Lucylight",
  "Farha",
  "Virginia",
  "Doroth",
  "Succour",
  "Sharon",
  "Debie",
  "Mercy",
  "Lurdi",
  "Camila",
  "Lina",
  "Schola",
  "Careen",
  "Suby",
  "Evelyn",
  "Princess",
  "Naseem",
  "Frola",
  "Zaina",
  "Gladness",
  "Clara",
  "Linzy",
  "Brihanna",
  "Laaziz",
  "Hellen",
  "Gracie",
  "Laura",
  "Asnathy",
  "Carie",
  "Lorrietasha",
  "Hartlyn",
  "Jacline",
  "Immaculata",
  "Iman",
  "Yolly",
  "Winnie",
  "Queen",
  "Rosalia",
  "Rosemary",
  "Shamya",
  "Skylers",
  "Petty",
  "James",
  "Emmanuel",
  "Jackson",
  "John",
  "Moses",
  "Michael",
  "Erick",
  "Daniel",
  "David",
  "Stanley",
  "Edwin",
  "Oscar",
  "Elijah",
  "Eric",
  "Thadei",
  "Raymond",
  "Boniface",
  "Dilip",
  "Hillary",
  "Paul",
  "Hassan",
  "Emanuel",
  "Baraka",
  "Edward",
  "Collins",
  "Bijal",
  "Kelvin",
  "Juma",
  "Benson",
  "Julius",
  "Samson",
  "Godfrey",
  "Prosper",
  "Paulo",
  "Pius",
  "Morgan",
  "Warner",
  "Almas Ally",
  "Jerry",
  "Onesmo",
  "Joel",
  "Manue",
  "Gift",
  "Kaggwa",
  "Ismaili",
  "Patrik",
  "Stanslaus",
  "Amos",
  "Nilly",
  "Taye",
  "Festus",
  "Gerald",
  "Aziz",
  "Mbonea",
  "Faiz",
  "Uromi",
  "Gabriel",
  "Freeman",
  "Godwill",
  "Gasper",
  "Steven",
  "Shariph",
  "David",
  "Robert",
  "Sokoine",
  "Evangle",
  "Cradle",
  "Abed",
  "Fahadi",
  "Mark",
  "Aiche",
  "Allan",
  "Hamis",
  "Boniface",
  "Celvin",
  "Pesa",
  "Hasheem",
  "Innocent",
  "Neema",
  "Bakari",
  "Jossal",
  "Reagan",
  "Zakaria",
  "Josh",
  "Robert",
  "Lodson",
  "Deogratius",
  "Kiwanga",
  "Oresto",
  "Costantine",
  "Freddy",
  "Nathaniel",
  "Geofrey",
  "Galosi",
  "Shakur",
  "Saludizo",
  "Frolian",
  "Peter",
  "Wilson",
];
